import { render, staticRenderFns } from "./Cities.vue?vue&type=template&id=6f422a12&scoped=true"
import script from "./Cities.vue?vue&type=script&lang=js"
export * from "./Cities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f422a12",
  null
  
)

export default component.exports